import React, { useEffect, useState } from 'react';
import {
  Paper, TableBody, Table, TableCell, TableContainer, TableHead, TableRow, Typography, Tooltip
} from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Select from 'react-select';
import { useDispatch } from 'react-redux';
import { IoCloseSharp } from 'react-icons/io5';
import { FaDownload } from 'react-icons/fa';
import { MdFilterAlt } from 'react-icons/md';
import { AiOutlineFileExcel } from 'react-icons/ai';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { format } from 'date-fns';
import 'dayjs/locale/en-gb';
import { getCategories } from '../../Services/Utils/ServiceProviderApis';
import GraphBlock from '../../components/Dashboard/GraphBlock';
import { planListView } from '../../Services/Utils/PlanApis';
import { downloadMISXL } from '../../Services/Utils/FileApis';
import { notifySet } from '../../Services/Actions/CommonActions';
import { isEmpty, STATUS_MSG } from '../../Services/config/globals';
import { UseStyles } from '../../components/TableStyles/tableSX';

function Dashboard() {
  const classes = UseStyles();
  const dispatch = useDispatch();
  // service provider chart
  const [chartData, setChartData] = useState([]);
  const [serviceProviderList, setServiceProviderList] = useState();
  useEffect(() => {
    const data01 = [];
    getCategories({ active: 'true' }, { start: 0, recordSize: '' }, 'private').then((res) => {
      res.list.map((data) => {
        if (data.serviceProviderViews?.length > 0) {
          data01.push({
            id: data.id,
            name: data.name,
            'Subscribers Count': data.count,
            serviceProviderList: data.serviceProviderViews
          });
        }
      });
      setChartData(data01);
    });
  }, []);
  let totalAmount = 0;

  const handleClickCell = (data) => {
    setServiceProviderList(data);
  };
  const chartOptions = [
    { id: 1, label: 'Bar Chart', value: 'bar' }
    // { id: 1, label: 'Pie Chart', value: 'pie' },
  ];
  // eslint-disable-next-line
  const [chartType, setChartType] = useState(chartOptions[0]);

  // plan chart
  let totalplanAmount = 0;
  const handleClickCellForPlan = (data) => {
    setPlanList(data);
  };
  // eslint-disable-next-line
  const [planChartType, setPlanChartType] = useState(chartOptions[0]);

  const [planChartData, setPlanChartData] = useState([]);
  const [planList, setPlanList] = useState();
  useEffect(() => {
    const data01 = [];
    planListView({}, { start: 0, recordSize: '' }).then((res) => {
      res.list.map((data) => {
        if (data.serviceProviderViews?.length > 0) {
          data01.push({
            id: data.id,
            name: data.name,
            'Subscribers Count': data.serviceProviderCount,
            serviceProviderList: data.serviceProviderViews
          });
        }
      });
      setPlanChartData(data01);
    });
  }, []);

  const downloadPdf = () => {
    const input = document.getElementById('downloadPdf');
    html2canvas(input, {
      logging: false, latterRendering: 1, useCORS: true, imageTimeout: 10000, scale: 2
    }).then((canvas) => {
      const imgWidth = 190;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      const imageData = canvas.toDataURL('image/png'); // eslint-disable-next-line
      const pdf = new jsPDF('p', 'mm', 'a4', true);
      pdf.setFillColor(245);
      pdf.rect(0, 0, 208, 700, 'F');
      pdf.addImage(imageData, 'PNG', 10, 10, imgWidth, imgHeight);
      pdf.save('downloadData.pdf');
    });
  };

  const downloadFile = () => {
    const data = { startDate, endDate };
    downloadMISXL('service-provider', data, { start: 0, recordSize: '' }).then((res) => {
      if (res.hasError === false) {
        dispatch(notifySet({ type: 'success', message: res.message }));
      } else if (res.hasError === true) {
        dispatch(notifySet({ type: 'error', message: res.message }));
      }
    });
  };

  // Select Filters
  const date = new Date();
  const [mainFilter, setMainFilter] = useState();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [monthlyFilter, setMonthlyFilter] = useState(0);
  const [yearlyFilter, setYearlyFilter] = useState(0);
  const [quarterlyFilter, setQuarterlyFilter] = useState(0);

  // default options
  const mainOptions = [
    { id: 1, label: 'Daily', value: 'daily' },
    { id: 2, label: 'Monthly', value: 'monthly' },
    { id: 3, label: 'Quarterly', value: 'quarterly' },
    { id: 4, label: 'Yearly', value: 'yearly' }
  ];
  // monthly options
  const monthOptions = ['January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];
  const getMonthName = (monthNumber) => (monthOptions[monthNumber]);
  const monthlyOptions = [];
  for (let m = 0; m < 12; m++) {
    monthlyOptions.push({
      id: (m + 1), value: (m + 1), label: getMonthName(m)
    });
  }
  function getMonthEndDate(month, year) {
    const monthEndDate = new Date(year, month + 1, 0);
    return monthEndDate.getDate();
  }
  // Quarterly Options
  const quarterlyOptions = [
    { label: 'Quarter 1', value: '01-01', endMonth: '03-31' },
    { label: 'Quarter 2', value: '04-01', endMonth: '06-30' },
    { label: 'Quarter 3', value: '07-01', endMonth: '09-30' },
    { label: 'Quarter 4', value: '10-01', endMonth: '12-31' }
  ];
  // yearly options
  const yearlyOptions = [];
  const currentYear = date.getFullYear();
  for (let i = 2023; i <= currentYear; i++) {
    yearlyOptions.push({
      id: i, label: i, value: i, start: `${i}-01-01`, end: `${i}-12-31`
    });
  }

  const handleMainFilter = (value) => {
    setMainFilter(value);
    setMonthlyFilter(0);
    setYearlyFilter(0);
    setQuarterlyFilter(0);
    setStartDate(null);
    setEndDate(null);
  };

  const handleMonthlyFilter = (monthlyValue) => {
    setMonthlyFilter(monthlyValue);
    if (!isEmpty(yearlyFilter)) {
      setStartDate(`${yearlyFilter.value}-${monthlyValue.value.toString().padStart(2, '0')}-01`);
      setEndDate(`${yearlyFilter.value}-${monthlyValue.value.toString().padStart(2, '0')}-${getMonthEndDate(Number(monthlyValue.value) - 1, Number(yearlyFilter?.value))}`);
    }
  };

  const handleYearlyFilter = (yearlyValue) => {
    setYearlyFilter(yearlyValue);
    if (mainFilter.value === 'monthly' && !isEmpty(monthlyFilter)) {
      setStartDate(`${yearlyValue.value}-${monthlyFilter.value.toString().padStart(2, '0')}-01`);
      setEndDate(`${yearlyValue.value}-${monthlyFilter.value.toString().padStart(2, '0')}-${getMonthEndDate(Number(monthlyFilter.value) - 1, Number(yearlyValue?.value))}`);
    } else if (mainFilter.value === 'quarterly' && !isEmpty(quarterlyFilter)) {
      setStartDate(`${yearlyValue.value}-${quarterlyFilter.value}`);
      setEndDate(`${yearlyValue.value}-${quarterlyFilter.endMonth}`);
    } else if (mainFilter.value === 'yearly') {
      setStartDate(yearlyValue.start);
      setEndDate(yearlyValue.end);
    }
  };

  const handleQuarterlyFilter = (quarterValue) => {
    setQuarterlyFilter(quarterValue);
    if (!isEmpty(yearlyFilter)) {
      setStartDate(`${yearlyFilter.value}-${quarterValue.value}`);
      setEndDate(`${yearlyFilter.value}-${quarterValue.endMonth}`);
    }
  };

  const handleChangeStartDate = (value) => {
    setStartDate(format(new Date(value), 'yyyy-MM-dd'));
  };
  const handleChangeEndDate = (value) => {
    setEndDate(format(new Date(value), 'yyyy-MM-dd'));
  };

  const handleClickFilter = () => {
    const data02 = [];

    if (isEmpty(startDate) || isEmpty(endDate)) {
      dispatch(notifySet({ type: 'error', message: STATUS_MSG.allFieldsMandatory }));
      return false;
    }

    if (Number(new Date(startDate)) > Number(new Date(endDate)) || Number(new Date(startDate)) === Number(new Date(endDate))) {
      dispatch(notifySet({ type: 'error', message: STATUS_MSG.endDateGreater }));
      return false;
    }

    const body = {
      active: 'true',
      startDate,
      endDate
    };
    if (yearlyFilter) {
      body.startDate = yearlyFilter.start;
      body.endDate = yearlyFilter.end;
    }
    if (quarterlyFilter) {
      body.startDate = `${yearlyFilter.value}-${quarterlyFilter.value}`;
      body.endDate = `${yearlyFilter.value}-${quarterlyFilter.endMonth}`;
    }
    if (monthlyFilter) {
      body.startDate = `${yearlyFilter.value}-${monthlyFilter.value.toString().padStart(2, '0')}-01`;
      body.endDate = `${yearlyFilter.value}-${monthlyFilter.value.toString().padStart(2, '0')}-${getMonthEndDate(Number(monthlyFilter.value) - 1, Number(yearlyFilter?.value))}`;
    }
    getCategories(body, { start: 0, recordSize: '' }, 'private').then((res) => {
      if (res.hasError === false) {
        res.list.map((data) => {
          if (data.serviceProviderViews?.length > 0) {
            data02.push({
              id: data.id,
              name: data.name,
              'Subscribers Count': data.count,
              serviceProviderList: data.serviceProviderViews
            });
          }
        });
        setChartData(data02);
      } else if (res.hasError === true) {
        setChartData([]);
        dispatch(notifySet({ type: 'error', message: res.message }));
      }
    });
  };

  return (
    <div className="row" id="downloadPdf">
      <div className="col-sm-2">
        <h6>Dashboard</h6>
      </div>
      <div className="col-sm-8">
        <div className="row">
          <div className="col-lg-3">
            <Select
              options={mainOptions}
              value={mainFilter}
              onChange={handleMainFilter}
              isSearchable={false}
            />
          </div>
          {!isEmpty(mainFilter?.value) && mainFilter?.value === 'daily' && (
            <>
              <div className="col-lg-3">
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
                  <DatePicker
                    onChange={handleChangeStartDate}
                    slotProps={{ textField: { variant: 'outlined', inputProps: { style: { background: 'white', height: '5px' } } } }}
                  />
                </LocalizationProvider>
              </div>
              <div className="col-lg-3">
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
                  <DatePicker
                    onChange={handleChangeEndDate}
                    slotProps={{ textField: { variant: 'outlined', inputProps: { style: { background: 'white', height: '5px' } } } }}
                  />
                </LocalizationProvider>
              </div>
            </>
          )}
          {!isEmpty(mainFilter?.value) && mainFilter?.value === 'monthly' && (
            <div className="col-lg-3">
              <Select
                options={monthlyOptions}
                value={monthlyFilter}
                onChange={handleMonthlyFilter}
                isSearchable={false}
                placeholder="Month"
              />
            </div>
          )}
          {!isEmpty(mainFilter?.value) && mainFilter?.value === 'quarterly' && (
            <div className="col-lg-3">
              <Select
                options={quarterlyOptions}
                value={quarterlyFilter}
                onChange={handleQuarterlyFilter}
                isSearchable={false}
                placeholder="Quarter"
              />
            </div>
          )}
          {!isEmpty(mainFilter?.value) && ['monthly', 'quarterly', 'yearly'].includes(mainFilter?.value) && (
          <div className="col-lg-3">
            <Select
              options={yearlyOptions}
              value={yearlyFilter}
              onChange={handleYearlyFilter}
              isSearchable={false}
              placeholder="Year"
            />
          </div>
          )}
          {mainFilter && (
          <div className="col-lg-1" style={{ marginLeft: '10px' }}>
            <MdFilterAlt
              className="addcircle"
              style={{ padding: '4px', cursor: 'pointer' }}
              onClick={handleClickFilter}
            />
          </div>
          )}
        </div>
      </div>
      {!isEmpty(chartData) && (
      <div className="col-sm-2">
        <FaDownload className="addcircle" style={{ padding: '6px', float: 'right' }} onClick={downloadPdf} />
        <AiOutlineFileExcel className="addcircle excel" style={{ float: 'right', marginRight: '10px', padding: '6px' }} onClick={downloadFile} />
      </div>
      )}
      <div className="col-sm-12 col-md-12 col-lg-6">
        <div className="product-detail-con text-center">
          <div className="product-detail-card">
            {/* <Select
              options={chartOptions}
              onChange={(value) => setChartType(value)}
              value={chartType}
              isSearchable={false}
            /> */}
            <GraphBlock
              type={chartType.value}
              handleClickCell={handleClickCell}
              chartData={chartData}
            />
            <h6>Categorywise Graphs of cummulative credits<br /> rolled out in $ </h6>
          </div>
        </div>
        <div>
          {serviceProviderList?.serviceProviderList?.length > 0 && (
            <Paper>
              <Typography
                align="center"
                sx={{ padding: '15px', marginTop: '5px' }}
              >
                Service Partners ({serviceProviderList.name})
                <Tooltip title="Close">
                  <span
                    style={{ float: 'right' }}
                    onClick={() => setServiceProviderList([])}
                  >
                    <IoCloseSharp style={{ fontSize: '25px' }} />
                  </span>
                </Tooltip>
              </Typography>
              <TableContainer component={Paper}>
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell>Name</TableCell>
                      <TableCell align="center">Subscriber</TableCell>
                      <TableCell align="right">Amount (in $)</TableCell>
                      <TableCell align="right">Total</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {serviceProviderList.serviceProviderList.map((row, index) => {
                      totalAmount += row.count * row.estimatedPerks;
                      return (
                        <TableRow key={index}>
                          <TableCell>{row.name}</TableCell>
                          <TableCell align="center">{row.count}</TableCell>
                          <TableCell align="right">{row.estimatedPerks}</TableCell>
                          <TableCell align="right">{row.count * row.estimatedPerks}</TableCell>
                        </TableRow>
                      );
                    })}
                    <TableRow className={classes.lastRow}>
                      <TableCell
                        align="right"
                        colSpan={3}
                      >
                        Total
                      </TableCell>
                      <TableCell align="right">$ {totalAmount}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          )}
        </div>
      </div>
      <div className="col-sm-12 col-md-12 col-lg-6">
        <div className="product-detail-con text-center">
          <div className="product-detail-card">
            {/* <Select
              options={chartOptions}
              onChange={(value) => setPlanChartType(value)}
              value={planChartType}
              isSearchable={false}
            /> */}
            <GraphBlock
              type={planChartType.value}
              handleClickCell={handleClickCellForPlan}
              chartData={planChartData}
            />
            <h6>Planwise Graphs of clicks<br />from start up side</h6>
          </div>
        </div>
        <div>
          {planList?.serviceProviderList?.length > 0 && (
            <Paper>
              <Typography
                align="center"
                sx={{ padding: '15px', marginTop: '5px' }}
              >
                Service Partners ({planList?.name})
                <Tooltip title="Close">
                  <span
                    style={{ float: 'right' }}
                    onClick={() => setPlanList([])}
                  >
                    <IoCloseSharp style={{ fontSize: '25px' }} />
                  </span>
                </Tooltip>
              </Typography>
              <TableContainer component={Paper}>
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell>Name</TableCell>
                      <TableCell align="center">Subscriber</TableCell>
                      <TableCell align="right">Amount (in $)</TableCell>
                      <TableCell align="right">Total</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {planList.serviceProviderList?.map((row, index) => {
                      totalplanAmount += row.subscribeCount * row.estimatedPerks;
                      return (
                        <TableRow key={index}>
                          <TableCell>{row.name}</TableCell>
                          <TableCell align="center">{row.subscribeCount}</TableCell>
                          <TableCell align="right">{row.estimatedPerks}</TableCell>
                          <TableCell align="right">{row.subscribeCount * row.estimatedPerks}</TableCell>
                        </TableRow>
                      );
                    })}
                    <TableRow className={classes.lastRow}>
                      <TableCell
                        align="right"
                        colSpan={3}
                      >
                        Total
                      </TableCell>
                      <TableCell align="right">$ {totalplanAmount}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          )}
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
